import { useUserContext } from "../../context/dashboard-context";
import CounterCard from "../card-counter";
import "./admin-about.scss";

const AdminAbout = () => {
  const { categorys, news, products, brands } = useUserContext();
  const data = [
    {
      title: "Barcha kategoriyalar",
      count: categorys?.length || 0,
    },
    {
      title: "Barcha Partnerlar",
      count: Array.isArray(brands) ? brands.length : 0,
    },
    {
      title: "Barcha mahsulotlar",
      count: products?.length || 0,
    },
    {
      title: "Barcha Yangiliklar",
      count: news?.length || 0,
    },
  ];

  console.log("✅ Brands in AdminAbout:", brands); // Add this

  return (
    <>
      <div className="admin-about">
        <h1>Admin </h1>
        <div className="about-cards">
          {data?.map((i, k) => (
            <CounterCard
              key={k}
              icon={i.icon}
              title={i.title}
              count={i.count}
            />
          ))}
        </div>
      </div>
    </>
  );
};
export default AdminAbout;
